var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHand = function SvgHand(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 10,
    "data-width-20": 13,
    "data-width-24": 15,
    viewBox: "0.9 1.4 11.8 14.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M4.9 10.8V4.3c0-.5.4-.9.9-.9s.9.4.9.9v1.8-3.2c0-.5.4-.9.9-.9s.9.4.9.9v3.2-2.3c0-.5.4-.9.9-.9s.9.4.9.9v3.4-1.6c0-.5.4-.9.9-.9s.9.4.9.9v4.7c0 2.5-2 4.6-4.5 4.6H7c-1.5 0-2.9-.8-3.6-2.1l-1.8-3c-.3-.6-.1-1.3.5-1.6s1.3-.1 1.6.5z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHand);
export default ForwardRef;